<template>
    <T-dialog @dialogClose="done =>
        { done(), close() }" :dialog="dialog">
        <div slot="content" :class="shit$(`h:450px; bgc:#fff; radius:10px;`)">
            <img :class="shit$(left.img.shit)" :src="left.img.src" />
            <section :class="shit$(describe.shit)" >
                <template v-for="(o2, index2) in describe.children">
                    <p :class="shit$(o2.shit)" :key="index2" >
                        {{ o2.txt }}
                    </p>
                </template>
            </section>

            <div :class="shit$(control.shit)">
                <el-button :class="shit$(control.button.shit)">
                    <span @click="close" :class="shit$(control.button.span.shit)">{{ control.button.span.txt }}</span>
                </el-button>
            </div> 
        </div>
    </T-dialog>
</template>

<script>
import TDialog from '@/code-lab/view/organization/s-dialog.vue'
import { mutations, store } from '@/code-lab/view/dialo-tip-wrapper/observable.js'

export default {
    components: {
        TDialog
    },
    methods: {
        openIntroSimulator () {
            this.$store.commit("SELECTEDMENUERIGHT", null)
            this.$store.dispatch ('introStore/excuteStackSimulator_', [ { type: 'simulatorDB', index: 0 } ])
        },
        close () {
            mutations.switch(false)
            this.$emit('close')
            this.$route.path === '/' && this.openIntroSimulator()
        },
    },
    computed: {
        dialog () { return store.dialog },
        view () { return store.view },
        left () { return this.view.left },
        position () { return this.view.position },
        describe () { return this.position.describe },
        control () { return this.position.control }
    },
}
</script>

<style lang="scss">
.dialo-tip-wrapper-normal {
    .el-dialog__header {
        padding: 0px!important;
    }
    .el-dialog__body {
        padding: 0px!important;
    }
    .el-dialog {
        border-radius: 10px!important;
        background: transparent!important;
    }
    border-radius: 10px!important;
    background: transparent!important;
}
</style>
